import { ProductCardSkeleton } from '@maestro/commerce-blocks/components/product-card'
import { Carousel } from '@pearlconvert/ui/components/carousel'

// The slider is a horizontal carousel, so only the first few cards are ever
// visible during loading. Rendering one skeleton card per real product just
// inflates the DOM React must tear down when the real content swaps in (a large
// chunk of hydration-time `removeChild`). Cap the placeholders to what fills the
// viewport — height is unchanged (horizontal scroll), so there is no CLS impact.
const MAX_SKELETON_CARDS = 6

const ProductSliderSkeleton = ({ length = 6 }: { length?: number }) => {
  const count = Math.min(Math.max(length, 1), MAX_SKELETON_CARDS)
  return (
    <Carousel showNavigationArrows={false}>
      {Array.from({ length: count }).map((_, index) => (
        <ProductCardSkeleton key={`ProductCardSkeleton-${index}`} />
      ))}
    </Carousel>
  )
}

export default ProductSliderSkeleton
